import axios from "axios";
import { getDeviceType, getBrowserType, fetchApiData, checkOperatingSystem, fetchApiDataV2, updateApiDataV2, updateApiData } from "../utils/utils";
const qs = require("query-string");

export const fetchAppInfo = async (params) => {
  const website = window.location.origin // For LIVE
  //  const website = 'https://fwfg.com';

  const customConfig = {
    headers: {
      website: website,
    },
    params: params && params,
  };
  return await axios.get(
    process.env.REACT_APP_API_URL + "config",
    customConfig
  );
};

export const fetchGeoInfo = async () => {
  return await axios.get("https://api.gizmott.com/api/v1/ipinfo");
};

export const getLanguageList = async (appInfo) => {
  const api = "language/list";
  return await fetchApiDataV2(appInfo, api);
};

export const updateUserLanguage = async (appInfo, lanuguageId) => {
  const api = "user/language/update";
  const location = {
    path: "common",
    values: { language_id: lanuguageId }
  }
  return await updateApiDataV2(appInfo, api, location)
}
export const updateExternalUser = async (appInfo, token) => {
  const api = "account/verify";
  const location = {
    path: "common",
    values: { token }
  }
  return await updateApiDataV2(appInfo, api, location)
}
export const emailRequestCheck = async (appInfo, id) => {
  const api = "account/request/check";
  const params = {
    id
  }
  return await fetchApiData(appInfo, api, params)
}

export const guestUser = async (appInfo) => {
  let countryCode = appInfo?.projectDetails?.geoInfo?.countryCode;
  let ipaddress = appInfo?.projectDetails?.geoInfo?.query;
  let deviceId = appInfo?.projectDetails?.device_id;
  let pubid = appInfo?.projectDetails?.projectConfig?.pubid;
  let channelid = appInfo?.projectDetails?.projectConfig?.channelid;
  const customConfig = {
    headers: {
      pubid: pubid,
      channelid: channelid,
      country_code: countryCode,
      device_type: "web",
      dev_id: deviceId,
      ip: ipaddress,
      ua: navigator.userAgent,
    },
  };
  return await axios.post(
    process.env.REACT_APP_API_URL + "account/register/guest",
    "",
    customConfig
  );
};

export const authenticate = (appInfo) => {
  let uId = localStorage.getItem("gid");
  let countryCode = appInfo?.projectDetails?.geoInfo?.countryCode;
  let ipaddress = appInfo?.projectDetails?.geoInfo?.query;
  let deviceId = appInfo?.projectDetails?.device_id;
  let pubid = appInfo?.projectDetails?.projectConfig?.pubid;
  let channelid = appInfo?.projectDetails?.projectConfig?.channelid;
  let user_id = localStorage.getItem("userId");
  if (user_id) {
    uId = user_id;
  }
  const customConfig = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Access-Control-Allow-Origin": true,
      crossorigin: true,
      uid: uId,
      pubid: pubid,
      country_code: countryCode,
      channelid: channelid,
      dev_id: deviceId,
      ip: ipaddress,
      device_type: "web",
    },
  };
  return axios
    .get(process.env.REACT_APP_API_URL + "account/authenticate", customConfig)
    .then((response) => {
      if (response?.data?.message === "Invalid user") {
      } else {
        return response.data;
      }
    });
};

export const authenticate2 = async (appInfo) => {
  const url = `account/authenticate`;
  const response = await fetchApiData(appInfo, url);

  const data = response?.data;
  if (data) {
    const currentLanguageCode = localStorage.getItem('selectedLanguageCode');
    const currentLanguageId = localStorage.getItem('selectedLanguageId');
    const currentLanguageName = localStorage.getItem('selectedLanguageName');

    if (currentLanguageCode !== data?.user_language?.short_code ||
      currentLanguageId !== data?.user_language?.language_id.toString() ||
      currentLanguageName !== data?.user_language?.language_name) {

      localStorage.setItem('selectedLanguageCode', data?.user_language?.short_code);
      localStorage.setItem('selectedLanguageId', data?.user_language?.language_id.toString());
      localStorage.setItem('selectedLanguageName', data?.user_language?.language_name);
      // if (currentLanguageCode !== undefined && currentLanguageId !== undefined && currentLanguageName !== undefined) {
      //   window.location.href = window.location.href;
      // }
    }
  }

  return response;
};

export const applaunchEvent = async (event, appInfo, aiType) => {
  let sessionId = appInfo?.sessionId;
  let uId = localStorage.getItem("gid");
  let user_id = localStorage.getItem("userId");
  if (user_id) {
    uId = user_id;
  }
  let device_id = appInfo?.projectDetails?.device_id;
  let ctimestamp = Date.now().toString();
  let ctime = ctimestamp.slice(0, 10);
  let appid = appInfo?.projectDetails?.projectConfig?.app_id;
  let pubid = appInfo?.projectDetails?.projectConfig?.pubid;
  let channelid = appInfo?.projectDetails?.projectConfig?.channelid;
  const requestBody = {
    app_id: appid,
    timestamp: ctime,
    device_id: device_id,
    event_type: event,
    publisherid: pubid,
    user_id: uId,
    channel_id: channelid,
    session_id: sessionId,
    ai_type: aiType && aiType,
  };
  var token = appInfo?.accessToken;
  const customConfig = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Access-Control-Allow-Origin": true,
      crossorigin: true,
      "access-token": token,
    },
  };

  return await axios.post(
    "https://analytics.poppo.tv/event",
    qs.stringify(requestBody),
    customConfig
  );
};

export const analytics = (Response_uid, appInfo, Response_email, user_name) => {
  let countryCode = appInfo?.projectDetails?.geoInfo?.countryCode;
  localStorage.setItem("device_analytics", "true");
  let uId = Response_uid ? Response_uid : localStorage.getItem("gid");
  let user = localStorage.getItem("userId")

  let user_id = Response_uid ? Response_uid : localStorage.getItem("userId");
  if (user_id) {
    uId = user_id;
  }
  let deviceId = appInfo?.projectDetails?.device_id;
  var token = appInfo?.accessToken;
  let sessionId = appInfo?.sessionId;
  let userEmail = Response_email ? Response_email : "";

  let appid = appInfo?.projectDetails?.projectConfig?.app_id;
  let deviceType = getDeviceType();
  let ctimestamp = Date.now().toString();
  let ctime = ctimestamp.slice(0, 10);
  let browserType = getBrowserType();
  let pubid = appInfo?.projectDetails?.projectConfig?.pubid;
  let channelid = appInfo?.projectDetails?.projectConfig?.channelid;
  const customConfig = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Access-Control-Allow-Origin": true,
      crossorigin: true,
      "access-token": token,
    },
  };
  let currentLocation = appInfo?.projectDetails?.geoInfo;
  const data = {
    session_id: sessionId,
    device_id: deviceId,
    publisherid: pubid,
    channelid: channelid,
    app_id: appid,
    user_id: uId,
    ip_address: currentLocation?.query,
    ua: navigator.userAgent,
    timestamp: ctime,
    country: currentLocation?.country,
    device_type: deviceType,
    city: currentLocation?.city,
    latitude: currentLocation?.lat,
    longitude: currentLocation?.lon,
    width: window.innerWidth,
    height: window.innerHeight,
    device_make: navigator.userAgent,
    device_model: navigator.userAgent,
    browser: browserType,
    user_name: user ? user_name : "guest",
    user_email: userEmail ? userEmail : "",
    user_contact_number: "",
    country_code: countryCode,
  };
  return axios
    .post("https://analytics.poppo.tv/device", qs.stringify(data), customConfig)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return [];
    });
};

export const analytics2 = async (Response_uid, appInfo, Response_email, user_name) => {
  let countryCode = appInfo?.projectDetails?.geoInfo?.countryCode;
  let uId = Response_uid ? Response_uid : localStorage.getItem("gid");
  let user = localStorage.getItem("userId")
  let user_id = Response_uid ? Response_uid : localStorage.getItem("userId");
  if (user_id) {
    uId = user_id;
  }
  let deviceId = appInfo?.projectDetails?.device_id;
  let sessionId = appInfo?.sessionId;
  let userEmail = Response_email ? Response_email : "";

  let appid = appInfo?.projectDetails?.projectConfig?.app_id;
  let deviceType = getDeviceType();
  let ctimestamp = Date.now().toString();
  let ctime = ctimestamp.slice(0, 10);
  let browserType = getBrowserType();
  let pubid = appInfo?.projectDetails?.projectConfig?.pubid;
  let channelid = appInfo?.projectDetails?.projectConfig?.channelid;
  const customConfig = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Access-Control-Allow-Origin": true,
      crossorigin: true,
    },
  };
  let currentLocation = appInfo?.projectDetails?.geoInfo;
  const data = {
    session_id: sessionId,
    device_id: deviceId,
    publisherid: pubid,
    channelid: channelid,
    app_id: appid,
    user_id: uId,
    ip_address: currentLocation?.query,
    ua: navigator.userAgent,
    timestamp: ctime,
    country: currentLocation?.country,
    device_type: deviceType,
    city: currentLocation?.city,
    latitude: currentLocation?.lat,
    longitude: currentLocation?.lon,
    width: window.innerWidth,
    height: window.innerHeight,
    device_make: navigator.userAgent,
    device_model: navigator.userAgent,
    browser: browserType,
    user_name: user ? user_name : "guest",
    user_email: userEmail ? userEmail : "",
    user_contact_number: "",
    country_code: countryCode,
  };
  return await axios.post(
    "https://analytics.poppo.tv/device",
    qs.stringify(data),
    customConfig
  );
};

export const getPlayerToken = async (appInfo, id) => {
  const api = "playlistV2/generateToken";
  const params = {
    id: id
  }
  return await fetchApiData(appInfo, api, params)
};

export const affliateAnalytics = async (appInfo) => {
  let deviceType;
  if (checkOperatingSystem() === "android") {
    deviceType = "Android"
  } else if (checkOperatingSystem() === "iPhone") {
    deviceType = "iPhone"
  }
  let pubid = appInfo?.projectDetails?.projectConfig?.pubid;
  let channelid = appInfo?.projectDetails?.projectConfig?.channelid;
  const url = localStorage.getItem("affliateUrl")
  const unique = deviceType && appInfo?.projectDetails?.geoInfo?.query + deviceType;
  let params = { url: url, source_application: document.referrer, unique_device_id: unique }
  let uid = localStorage.getItem("gid");
  let user_id = localStorage.getItem("userId");
  if (user_id) {
    uid = user_id;
  }
  const customConfig = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Access-Control-Allow-Origin": true,
      crossorigin: true,
      pubid: pubid,
      channelid: channelid,
      uid: uid,
      device_type: "web"
    },
    params: params
  };

  return await axios.get(
    "https://api.gizmott.com/api/v1/affiliate/analytics",
    customConfig
  );
};
export const updateContinueWatching = async (appInfo, videoId) => {
  const api = "user/continueWatching/remove";
  const location = {
    path: "common",
    values: { video_id: videoId }
  };
  return await updateApiData(appInfo, api, location);
};

export const updateWatchlistData = async (appInfo, showId, flag) => {
  const api = `watchlist/show/${showId}/${flag}`;
  return await fetchApiData(appInfo, api);
};

export const getUserSubscription = async (appInfo) => {
  const api = "subscription/user";
  return await fetchApiData(appInfo, api);
};

export const getUserLastSubscriptionDetails = async (appInfo) => {
  const api = "subscription/lastExpired";
  return await fetchApiData(appInfo, api);
};

export const logoutAll = async (appInfo) => {
  const api = "account/logoutall";
  return await fetchApiData(appInfo, api);
};

export const updateStreakSettings = async (appInfo, enabled) => {
  const api = "user/streak";
  const location = {
    path: "common",
    values: { enabled }
  };
  return await updateApiData(appInfo, api, location);
};

export const fetchEventDetails = async (appInfo, eventId) => {
  const api = "subscription/event";
  const params = {
    event_id: eventId
  }
  return await fetchApiData(appInfo, api, params)
}
export const updateUserRating = async (appInfo, values) => {
  const api = "user/rating"
  const data = {
    show_id: values?.showId,
    rating: values?.ratedCount,
    review: values?.review
  }
  const location = {
    path: "common",
    values: data
  }
  return await updateApiData(appInfo, api, location)
}

export const getUpdatePaymentLink = async (appInfo) => {
  const api = `user/paymentMethod/session`
  return await updateApiData(appInfo, api)
}

export const listVideosByDate = async (appInfo, startDate, endDate) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const api = "calendar/list";
  const params = {
    start_date: startDate,
    end_date: endDate,
    timezone: timeZone,
  };
  return await fetchApiData(appInfo, api, params);
};

export const addVideoToDate = async (appInfo, videoId, date) => {
  const api = "calendar/add";
  const location = {
    path: "common",
    values: {
      video_id: videoId,
      date: date,
    },
  };
  return await updateApiData(appInfo, api, location);
};

export const fetchCalendarVideos = async (appInfo, searchKey = "") => {
  const api = "calendar/videos";
  const params = searchKey ? { key: searchKey } : {};
  return await fetchApiData(appInfo, api, params);
};

export const deleteVideoFromCalendar = async (appInfo, calendarId) => {
  const api = "calendar/delete";
  const location = {
    path: "common",
    values: {
      calendar_id: calendarId,
    },
  };
  return await updateApiData(appInfo, api, location);
};

export const updateVideoComplete = async (appInfo, calendarId, completed) => {
  const api = "calendar/video/complete";
  const location = {
    path: "common",
    values: {
      calendar_id: calendarId,
      completed: completed,
    },
  };
  return await updateApiData(appInfo, api, location);
}

export const createPlaylist = async (appInfo, title) => {
  const api = "playlist/create";
  const location = {
    path: "common",
    values: {
      title: title,
    },
  };
  return await updateApiData(appInfo, api, location);
}

export const updatePlaylist = async (appInfo, showId, playlistIds) => {  
  const api = "playlist/update";
  const location = {
    path: "show-playlist-update",
    values: {
      show_id : showId,
      id: playlistIds,
    },
  };
  return await updateApiData(appInfo, api, location);
}

export const getPlaylists = async (appInfo) => {
  const api = "playlist/list";
  return await fetchApiData(appInfo, api);
};

export const deletePlaylist = async (appInfo, playlistId) => {  
  const api = "playlist/delete";
  const location = {
    path: "common",
    values: {
      playlist_id : playlistId,
    },
  };
  return await updateApiData(appInfo, api, location);
}